import { UserId } from "@vowkey/common/types/guid";
import { UserKey } from "@vowkey/common/types/key";
import { BiometricsService, BiometricsStatus } from "@vowkey/key-management";
// eslint-disable-next-line no-restricted-imports
import { SymmetricCryptoKey } from "@vowkey/legacy-crypto";

export class WebBiometricsService extends BiometricsService {
  async authenticateWithBiometrics(): Promise<boolean> {
    return false;
  }

  async getBiometricsStatus(): Promise<BiometricsStatus> {
    return BiometricsStatus.PlatformUnsupported;
  }

  async unlockWithBiometricsForUser(userId: UserId): Promise<UserKey | null> {
    return null;
  }

  async getBiometricsStatusForUser(userId: UserId): Promise<BiometricsStatus> {
    return BiometricsStatus.PlatformUnsupported;
  }

  async getShouldAutopromptNow(): Promise<boolean> {
    return false;
  }

  async setShouldAutopromptNow(value: boolean): Promise<void> {}

  async canEnableBiometricUnlock(): Promise<boolean> {
    return false;
  }
  async setBiometricProtectedUnlockKeyForUser(
    userId: UserId,
    value: SymmetricCryptoKey,
  ): Promise<void> {}
  async enrollPersistent(userId: UserId, key: SymmetricCryptoKey): Promise<void> {}
  async hasPersistentKey(userId: UserId): Promise<boolean> {
    return false;
  }
  async deleteBiometricUnlockKeyForUser(userId: UserId): Promise<void> {}
}
